export enum SystemFlagsEnum {
  IS_UPLOADING_PHOTO = 'isUploadingPhotos',
  SEND_INSPECTION_IDENTIFIER = 'sendingInspectionId',
}
